export default {
  ENTER: 13,
  TAB: 9,
  ESC: 27,
  SPACE: 32
}
